import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import settings from "settings"
import BuildForm from './buildForm'
import { Redirect } from 'react-router-dom'
import axios from 'axios'
import { compose } from "redux"
import { loadingStatus } from "../actions"

class PipsyForm extends Component {

    constructor(props) {
        super(props)
        this.state = {
            redirect: false,
            redirectPath: ''
        }
    }

    _handleSubmit = (e) => {
        e.preventDefault()
        //console.log(this.state.fields)
        //return
        
        if (this.props.valid) {
            // throw up loading
            this.props.loadingStatus(true)
            //IDs of column names should match
            var qs = require('qs')
            // send all requests with authorization token
            var user = localStorage.getItem('user')
            axios.post(
                settings.ep + '/' + this.props.submit,
                qs.stringify(this.props.fields),
                {headers: { 'Authorization': `Bearer ${user}`}}
            )
            .then(response => {
                this.props.loadingStatus(false)
                if(response.data.status == 200) {
                    this.setState({
                        redirectPath: response.data.redirect,
                        redirect:true
                    })
                }
            })
            .catch(error => {
                console.log(error)
            })
        } else {
            // This is where issue#1 should go
            this.props.alert.show('Please ensure all fields are properly filled out.', {type: 'error'})
            console.log("not valid")
        }
    }

    render() {
        var classNames = require('classnames')
        var submitClasses = classNames(
            'form__submit', {
                'form__submit--ready': this.props.valid
            }
        )
        if(this.state.redirect) {
            //console.log(this.state)
            // if we successfully add a sale, redirect.
            return <Redirect to={this.state.redirectPath} />
        }
        else {
            return (
                <div className="pipsyForm">
                    <form onSubmit={this._handleSubmit}>
                        <ul className="form__list">
                            <BuildForm editing={this.props.editing} fields={this.props.fields} setValid={this.props.setValid} updateValue={this.props.updateValue} removeRow={this.props.removeRow}  />
                        </ul>
                        <input type="submit" value="Submit" className={submitClasses} />
                    </form>
                </div>
            )
        }
    }
}


function mapStateToProps(state) {
    return {

    }
}

function matchDispatchToProps(dispatch) {
    return bindActionCreators({
        loadingStatus:loadingStatus
    }, dispatch)
}

export default compose(connect(mapStateToProps, matchDispatchToProps))(PipsyForm)